import ApproverExpenseReportsReducer, {
  Actions as ExpensesAllReportsActions,
  ApproverExpenseReportsState,
  initialState as initialExpensesAllReportsState,
} from 'src/app/ApproverExpenseReports/redux/approverExpenseReports.reducer'
import SubmitterUsersReducer, {
  Actions as SubmitterUsersActions,
  initialState as initialSubmitterUsersState,
  SubmitterUsersState,
} from 'src/app/ApproverExpenseReports/redux/submitterUsers.reducer'
import SubmitterExpenseReportsReducer, {
  Actions as ExpensesYourReportsActions,
  initialState as initialExpensesYourReportsState,
  SubmitterExpenseReportsState,
} from 'src/app/SubmitterExpenseReports/redux/submitterExpenseReports.reducer'

export type ExpenseReportsState = {
  expensesAllReports: ApproverExpenseReportsState
  expensesYourReports: SubmitterExpenseReportsState
  submitterUsers: SubmitterUsersState
}

export const initialState: ExpenseReportsState = {
  expensesAllReports: initialExpensesAllReportsState,
  expensesYourReports: initialExpensesYourReportsState,
  submitterUsers: initialSubmitterUsersState,
}

export type Actions =
  | ExpensesAllReportsActions
  | ExpensesYourReportsActions
  | SubmitterUsersActions

const ExpenseReportsReducer = (
  state = initialState,
  action: Actions,
): ExpenseReportsState => ({
  expensesAllReports: ApproverExpenseReportsReducer(
    state.expensesAllReports,
    action as ExpensesAllReportsActions,
  ),
  expensesYourReports: SubmitterExpenseReportsReducer(
    state.expensesYourReports,
    action as ExpensesYourReportsActions,
  ),
  submitterUsers: SubmitterUsersReducer(
    state.submitterUsers,
    action as SubmitterUsersActions,
  ),
})

export default ExpenseReportsReducer
